// To remove with `forge-ui-modifications-validation-errors-returned-to-app_hdzmw` FF clean up
type ErrorAttributes = { fieldType: string; fieldId: string };
export class IssueAdjustmentFieldPropertyError extends Error {
	attributes: ErrorAttributes;

	constructor(message: string, attributes: ErrorAttributes, cause?: unknown) {
		super();

		this.message = message;
		this.attributes = attributes;
		this.cause = cause;
	}
}
